/**
 * Asynchronously loads the component for LeadListPage
 */

import { lazyLoad } from 'utils/loadable';

export const LeadListPage = lazyLoad(
  () => import('./index'),
  module => module.LeadListPage,
);
